// extracted by mini-css-extract-plugin
export default {"select":"oryx-select_select__bZMNw","select__wrapper":"oryx-select_select__wrapper__zzsUU","select-invalid":"oryx-select_select-invalid__l9JAg"};